import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { HeadCellType, priceRowType, summaryRowType } from "../../../utils/appConstants";
import ElipsisCell from "../../DesignSystem/Table/Cells/ElipsisTextCell";
import { currencyFormatter } from "../../../utils/methods";

export const incomeHeadCells: HeadCellType[] = [
  {
    id: "customer",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Customer",
    width: "40%",
  },
  {
    id: "total",
    align: "right",
    disablePadding: false,
    sortEnabled: false,
    label: "Billing Period",
    width: "30%",
  },
  {
    id: "mrc",
    align: "right",
    disablePadding: false,
    sortEnabled: false,
    label: "Monthly Recurring Income",
    width: "30%",
  },
];

export const expenseHeadCells: HeadCellType[] = [
  {
    id: "provider",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Provider",
    width: "40%",
  },
  {
    id: "total",
    align: "right",
    disablePadding: false,
    sortEnabled: false,
    label: "Billing Period",
    width: "30%",
  },
  {
    id: "mrc",
    align: "right",
    disablePadding: false,
    sortEnabled: false,
    label: "Monthly Recurring Charges",
    width: "30%",
  },
];

interface SummaryRowProps {
  row: summaryRowType;
  type: "expense" | "income";
  notApplicable?: boolean;
}

const SummaryRow: React.FC<SummaryRowProps> = ({ row, type, notApplicable }) => {
  const formatRow = (priceType: "mrc" | "billing"): string => {
    const price = priceType === "mrc" ? row.monthlyRecurring : row.currentBillingPeriod;
    if (type === "expense") {
      return `( $${currencyFormatter(price)} )`;
    }
    return `$${currencyFormatter(price)}`;
  };
  return (
    <TableRow>
      <ElipsisCell bold={row.total} width="40%" align="left" text={row.company} />
      <ElipsisCell bold={row.total} className="number-cell" width="30%" align="right" text={`${formatRow("billing")}`} />
      <ElipsisCell bold={row.total} className="number-cell" width="30%" align="right" text={notApplicable ? "" : `${formatRow("mrc")}`} />
    </TableRow>
  );
};

export default SummaryRow;
